var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import typeConfig from './typeConfig';
import styles from './Exception.module.less';
import { ErrorBlock } from 'antd-mobile';
import { ExclamationCircleOutline } from 'antd-mobile-icons';
var Exception = function (_a) {
    var _b = _a.type, type = _b === void 0 ? '404' : _b, title = _a.title, description = _a.description;
    // 断言 type 的值是对象 typeConfig 的 key
    var config = typeConfig[type];
    return (_jsx("section", __assign({ className: styles.exceptionContainer }, { children: _jsx("div", __assign({ className: styles.exceptionContainer }, { children: config ?
                _jsxs(_Fragment, { children: [_jsx(ExclamationCircleOutline, { color: "#f26161", fontSize: 40 }), _jsx("h1", __assign({ className: styles.h1 }, { children: title || (config === null || config === void 0 ? void 0 : config.title) })), _jsx("div", __assign({ className: styles.description }, { children: description || (config === null || config === void 0 ? void 0 : config.desc) }))] })
                :
                    _jsx(ErrorBlock, { status: 'empty', title: _jsx("span", __assign({ className: styles.h1 }, { children: title })), description: _jsx("span", __assign({ className: styles.description }, { children: description })) }) })) })));
};
export default Exception;
